import { NiceModalHandler, useModal } from '@ebay/nice-modal-react';
import { useCallback, useMemo } from 'react';

import { editProfilePopupModalId } from './edit-profile-popup';
import { EditProfilePopupProps } from './edit-profile-popup.types';

export const useEditProfilePopup = () => {
  const { show }: NiceModalHandler<EditProfilePopupProps> = useModal(editProfilePopupModalId);
  const open = useCallback(
    (props: EditProfilePopupProps = {}) => {
      show(props);
    },
    [show],
  );
  return useMemo(() => ({ open }), [open]);
};
